const intervals = [];
const timeouts = [];

function setManagedInterval(callback, interval) {
    const intervalId = window.setInterval(callback, interval);
    intervals.push(intervalId);
    return intervalId;
}

function setManagedTimeout(callback, timeout) {
    const timeoutId = window.setTimeout(callback, timeout);
    timeouts.push(timeoutId);
    return timeoutId;
}

function clearAllIntervals() {
    for (const intervalId of intervals) {
        window.clearInterval(intervalId);
    }
    for (const timeoutId of timeouts) {
        window.clearTimeout(timeoutId);
    }
    intervals.length = 0;
    timeouts.length = 0;
}

export { setManagedInterval, setManagedTimeout, clearAllIntervals };